import React, { Component, ReactNode } from 'react'
import { Trans } from '@lingui/macro'
import { ceil } from 'lodash'

import Pagination from '../pagination/Pagination'

export interface IListFooterProps {
  itemsCount: number
  page?: number
  onPageChange?: (page: number) => void
  pageSize?: number
  actions?: ReactNode
}

export class ListFooter extends Component<IListFooterProps> {
  static defaultProps: Partial<IListFooterProps> = {
    pageSize: 20
  }

  isPaginated() {
    const { page, onPageChange } = this.props

    // @ts-expect-error 9/11/2020
    return page >= 0 && onPageChange
  }

  renderPagination() {
    const { page, pageSize, itemsCount, onPageChange } = this.props
    // @ts-expect-error 9/11/2020
    const totalPages = ceil(itemsCount / pageSize)
    if (!this.isPaginated() || totalPages <= 1) {
      return null
    }

    return (
      <Pagination
        totalPages={totalPages}
        page={page!}
        onPageChange={onPageChange!}
      />
    )
  }

  renderActions() {
    const { actions } = this.props
    return <div className="Actions">{actions}</div>
  }

  render() {
    const { itemsCount } = this.props

    return (
      <div className="ListFooter">
        <div className="Totals">
          <Trans>{itemsCount} found</Trans>
        </div>
        {this.renderPagination()}
        {this.renderActions()}
      </div>
    )
  }
}

export default ListFooter
